import styled from 'styled-components';
import React from 'react';

export const StyledTitle = styled.div`
  background: #fff;
  height: 56px;
  padding: 12px 0 12px 24px;
  display: flex;
  align-items: center;
  gap: 0;
  align-self: stretch;
  overflow: hidden;
  color: #000;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  /* 18M */
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
`;

export const StyledContentWrapper = styled.div`
  flex: 1;
  height: 100%;
  overflow: scroll;
`;

export const StyledFooterWrapper = styled.div`
  background: #fff;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.1);
`;

export const StyledWrapper = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  height: 100%;
  min-width: 560px;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  background: #fff;
`;

export const StyledFormError = styled.div`
  text-align: right;
  background-color: #fff1f0;
  color: #f5222d;
  padding: 8px 24px;
`;
